import APIClient from "../../../common/APIClient";

import { displayError } from "../commonActions";
import qs from "qs";

const GET_APP_CLICKS = "GET_APP_CLICKS";
const GET_USER_LOGINS = "GET_USER_LOGINS";
const REFRESH_REPORTS = "REFRESH_REPORTS";

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};

export const refreshReports = () => {
  return (dispatch) => {
    dispatch({ type: REFRESH_REPORTS });
  };
};

export const getAppClicks = (filters) => {
  return (dispatch) => {
    return client()
      .get("app-clicks/list", {
        params: {
          filters,
          limit: 10000,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((result) => {
        const json = result.data;
        if (json) {
          let appClicks = json.data;
          if (appClicks.length === 0) {
            appClicks = null;
          }
          dispatch({ type: GET_APP_CLICKS, appClicks });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const getUserLogins = (filters) => {
  return (dispatch) => {
    return client()
      .get("users/last-logins", {
        params: {
          filters,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((result) => {
        const json = result.data;
        if (json) {
          let userLogins = json.data;
          if (userLogins.length === 0) {
            userLogins = null;
          }
          dispatch({ type: GET_USER_LOGINS, userLogins });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const generateExportData = (exportHeaders, exportData) => {
  let data = [exportHeaders];

  exportData.forEach((dataRow) => {
    let row = [];

    Object.keys(dataRow).forEach((key) => {
      row.push(dataRow[key]);
    });

    data.push(row);
  });

  return data;
};
